import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'
import app from './modules/app'
Vue.use(Vuex)
const debug = process.env.NODE_ENV !== 'production'
const getPlugins = () => {
  const plugins = []
  if (debug) {
    plugins.push(createLogger())
  }
  return plugins
}

export default new Vuex.Store({
  modules: {
    app
  },
  state: {
    homeTab: [{
      tab: 0
    }, {
      tab: 0
    }]
  },
  mutations: {
    setTab (state, [key, value]) {
      state.homeTab[key] = value
    }
  },
  strict: debug,
  plugins: getPlugins()
})
